const normalizeOptions = (result) => {
	const options = Array.isArray(result) ? result : Array.isArray(result?.items) ? result.items : Array.isArray(result?.data) ? result.data : [];

	return [...new Map(options.map((item) => [Number(item.id), item])).values()];
};

const loadFallbackOptions = (Interface) =>
	Interface.request("get", { class: "data", module: "depositLadder", method: "list" }, {
		page: 1,
		limit: 1000,
		sorting: { column: "name", order: "ASC" },
	})
		.then(normalizeOptions)
		.then((ladders) =>
			Promise.all(
				ladders.map((ladder) =>
					Interface.request("get", { class: "data", module: "depositLadder", method: "get" }, { id: ladder.id }),
				),
			),
		);

export const loadDepositLadderBannerOptions = (Interface) =>
	Interface.request("get", { class: "data", module: "depositLadder", method: "getBannerOptions" }, {})
		.then(normalizeOptions)
		.then((options) => (options.length ? options : loadFallbackOptions(Interface)))
		.catch(() => loadFallbackOptions(Interface));
